
const saveDept = (ctx,deptInfo)=>{
  ctx.commit('saveDept',deptInfo)
}
// 保存添加银行卡信息
const saveCardInfo = (ctx,cardInfo)=>{
  ctx.commit('saveCardInfo',cardInfo)
}
// 保存输入提现信息
const saveCashOut = (ctx,cashoutInfo)=>{
  ctx.commit('saveCashOut',cashoutInfo)
}
export default{
  saveDept,
  saveCardInfo,
  saveCashOut
}


// WEBPACK FOOTER //
// ./src/store/actions.js